import { render } from "./ModalQnaProductResultOption.vue?vue&type=template&id=2a9d2ce5&scoped=true"
import script from "./ModalQnaProductResultOption.vue?vue&type=script&lang=js"
export * from "./ModalQnaProductResultOption.vue?vue&type=script&lang=js"

import "./ModalQnaProductResultOption.vue?vue&type=style&index=0&id=2a9d2ce5&scoped=true&lang=css"
import "./ModalQnaProductResultOption.vue?vue&type=style&index=1&id=2a9d2ce5&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9d2ce5"]])

export default __exports__